import React, { useRef, useState } from 'react'
import { Box, Button, Card, CardContent, CardMedia, Typography } from '@mui/material';
import { typeIcons } from 'utils/constant';
import { Add, Remove } from '@mui/icons-material';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import "./style.css";
import CustomTypography from 'components/Fileds/CustomTypography';
import CustomTooltip from 'components/Fileds/CustomTooltip';
import addIcon from "assests/addIcon.svg"
import { formatCurrency } from 'utils/function';

const ItemCard = ({
    item, itemQuantity, orderType, handleAddClick, removeItemFromOrder, theme, userData
}) => {
    const allergyText = item?.allergies?.map(a => typeof a === 'object' ? (a.name || a.title || '') : a).filter(Boolean).join(', ');

    return (
        <Card
            className='menu-item-card-container'
            sx={{
                height: {
                    xs: 160,
                    sm: 185,
                    md: orderType ? 230 : 220,
                },
            }}
        >
            {/* Image & Badges Container */}
            <Box sx={{ position: 'relative', flexShrink: 0, width: '100%', height: { xs: 100, sm: 120, md: 138 }, overflow: 'hidden' }}>
                <Box className='overlay-container' sx={{ height: { xs: 60, sm: 80, md: 100 } }} />

                {/* Official icon for food type */}
                <Box
                    component="img"
                    src={typeIcons[item.type]}
                    alt={item.type}
                    className='food-type-icon'
                />

                {/* Add-Ons badge */}
                {item.hasAddOns && (
                    <Box component="span" className='add-ons-label'>
                        Add-Ons
                    </Box>
                )}

                {/* Allergy Warning Badge */}
                {allergyText && (
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: '8px',
                            right: '8px',
                            zIndex: 9,
                        }}
                    >
                        <CustomTooltip title="Contains" content={allergyText} placement="top-end">
                            <Box
                                sx={{
                                    width: '24px',
                                    height: '24px',
                                    borderRadius: '50%',
                                    backgroundColor: '#FFFFFF',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.25)',
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                }}
                            >
                                <ReportProblemOutlinedIcon sx={{ color: '#E53935', fontSize: '14px' }} />
                            </Box>
                        </CustomTooltip>
                    </Box>
                )}

                <CardMedia
                    component="img"
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                    image={`${process.env.REACT_APP_API_ROUTE}/files/${item?.image}`}
                    alt={item.name}
                />
            </Box>

            <CardContent className='card-content-menu-item'>
                <Box className='menu-card-content-container'>
                    <CustomTypography
                        label={item?.name}
                        variant="body2"
                        sx={{
                            fontWeight: 700,
                            fontSize: {
                                xs: "0.75rem",
                                sm: "0.875rem",
                                md: "0.875rem",
                            },
                            lineHeight: 1.4, // Adjust line height for better text display
                            position: "relative",
                            zIndex: 1,
                            mb: 0,
                            color: theme.palette.typographyLabel.main
                        }}
                    />
                </Box>

                <Box className='d-flex align-items-center justify-content-between'>
                    <CustomTypography
                        variant="body1"
                        label={
                            formatCurrency(item.price.toFixed(2) || 0, userData.vendor.currency)
                        }
                        sx={{
                            fontWeight: "bold",
                            fontSize: { xs: "0.875rem", sm: "1rem", md: "1rem" },
                            color: theme.palette.highlight.main,
                            mb: 0
                        }}
                    />

                    {/* Add button or quantity controls based on whether item is in cart */}
                    {orderType && (
                        <>
                            {itemQuantity > 0 ? (
                                <Box className='quantity-cart-item-container'
                                    sx={{ border: `1px solid ${theme.palette.primary.main}` }}
                                >
                                    <Button
                                        sx={{ color: theme.palette.primary.main }}
                                        className='quantity-cart-item'
                                        onClick={() => removeItemFromOrder(item.id, item.addOns, item.size)}
                                    >
                                        <Remove fontSize="16px" />
                                    </Button>
                                    <Typography sx={{ mx: 1 }}>{itemQuantity}</Typography>
                                    <Button
                                        className='quantity-cart-item'
                                        sx={{ color: theme.palette.primary.main }}
                                        onClick={() => handleAddClick(item)}
                                    >
                                        <Add fontSize="16px" />
                                    </Button>
                                </Box>
                            ) : (
                                <Button
                                    className='add-cart-item-btn'
                                    sx={{
                                        border: `1px solid ${theme.palette.primary.main}`,
                                        color: theme.palette.primary.main,
                                    }}
                                    onClick={() => handleAddClick(item)}
                                >
                                    <Box className='d-flex align-items-center' sx={{ lineHeight: 'normal' }}>
                                        <img src={addIcon} alt='add' />
                                        Add
                                    </Box>
                                </Button>
                            )}
                        </>
                    )}
                </Box>
            </CardContent>
        </Card>
    )
}

export default ItemCard
